
import Vue from 'vue'

import { ClientPageConfigHeader, HeaderContent, PageThemeCustomization } from '@/types'

import { dateHelper } from '@/helpers/dateHelper'
import { i18n, AVAILABLE_LANGUAGES, TRANSLATED_LANGUAGES } from '@/plugins/i18n'

export default Vue.extend({
  name: 'fo-header',
  props: {
    content: {
      type: Object as () => HeaderContent,
      required: true,
    },
    config: {
      type: Object as () => ClientPageConfigHeader,
      required: true,
    },
    theme: {
      type: Object as () => PageThemeCustomization,
      required: false,
      default: () => ({
        backgroundColor: '#FFFFFF',
      }),
    },
    availableLanguages: {
      type: Array,
      default: () => AVAILABLE_LANGUAGES,
    },
    dataId: {
      type: String,
      required: true,
    },
  },
  data: () => ({ dateHelper }),
  computed: {
    cssGetBackgroundColor() {
      return {
        '--header-bg-color': this.theme.backgroundColor ?? '#FFFFFF',
      }
    },
    countriesNames() {
      return AVAILABLE_LANGUAGES.reduce((languagesNames, language) => {
        languagesNames = { ...languagesNames, [language]: TRANSLATED_LANGUAGES[`${language}`] }
        return languagesNames
      }, {})
    },
    getDates() {
      let currentValue = ''

      if (this.config.showOrderCreationDate && this.content.createdAt) {
        currentValue = this.$t('common.from', {
          date: dateHelper.formatToTimezone(this.content.createdAt, this.content.timezone, 'P'),
        })
      }

      if (this.config.showDeliveryDate && this.content.deliveryDate) {
        currentValue = `${currentValue} ${this.$t('common.on', {
          date: dateHelper.formatToTimezone(this.content.deliveryDate, this.content.timezone, 'P'),
        })}`
      }

      if (this.config.showPickingDate && this.content.pickingDate) {
        currentValue = dateHelper.formatToTimezone(
          this.content.pickingDate,
          this.content.timezone,
          'P',
        )
      }

      return currentValue
    },
    countries() {
      return this.availableLanguages
    },
    showHeader() {
      return Object.values(this.config).some(value => value) || this.availableLanguages.length > 1
    },
  },
  methods: {
    changeLanguage(language: string): void {
      i18n.changeLanguage(language)
      dateHelper.changeLocale(language)
      // This force update of i18n system to allow the use of this.$t in methods and computeds
      this.$root.$i18n.i18nLoadedAt = dateHelper.getDate().toString()

      this.$emit('changeLanguage', language)
    },
  },
})
